"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = require("../../runtime/dom");
var TileWrapper = /** @class */ (function (_super) {
    __extends(TileWrapper, _super);
    function TileWrapper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TileWrapper.prototype.findLabel = function () {
        return this.find('.awsui-tiles__tile-container');
    };
    TileWrapper.prototype.findDescription = function () {
        return this.find('.awsui-radio-button-description');
    };
    TileWrapper.prototype.findImage = function () {
        return this.find('.awsui-tiles__image');
    };
    TileWrapper.prototype.findNativeInput = function () {
        return this.findRadioButton().findNativeInput();
    };
    return TileWrapper;
}(dom_1.ElementWrapper));
exports.default = TileWrapper;
//# sourceMappingURL=awsui-tile.js.map